import Glide from '@glidejs/glide';

export default function initiateSlider() {
    /* Initialise hero slider */
    const heroCarousel = new Glide('.js-hero-carousel', {
        type: 'carousel',
        autoplay: 8000,
        gap: 0,
        perView: 1,
        hoverpause: false,
    });
    if (document.querySelector('.js-hero-carousel')) {
        heroCarousel.mount();
    }

    const hCarousel = document.querySelector('.js-hero-carousel');

    if (!hCarousel) {
        return;
    }

    if (hCarousel.classList.contains('paused')) {
        heroCarousel.pause();
    }

    /* Pause/Play */
    const pauseButton = document.getElementById('hero-pause');
    const playButton = document.getElementById('hero-play');

    function showProgressBar() {
        document
            .querySelector('.glide__bullets_wrapper')
            .classList.remove('hide');
    }

    function showPauseButton() {
        if (!hCarousel.classList.contains('paused')) {
            pauseButton.classList.add('hidden');
            playButton.classList.remove('hidden');
        }
    }

    function toggleControlButtons() {
        pauseButton.classList.toggle('hidden');
        playButton.classList.toggle('hidden');
    }

    pauseButton.addEventListener('click', () => {
        hCarousel.classList.add('paused');
        heroCarousel.pause();
        toggleControlButtons();

        /* stop blue progress line where it currently is */
        const innerBlue = document.querySelector(
            '.glide__bullet--active .glide__bullet-inner'
        );
        const computedStyle = window.getComputedStyle(innerBlue);
        const blueWidth = computedStyle.getPropertyValue('width');
        innerBlue.style.width = blueWidth;
    });

    playButton.addEventListener('click', () => {
        toggleControlButtons();
        showProgressBar();

        if (hCarousel.classList.contains('paused')) {
            /* resume progress bar from stopped position */
            const innerBlue = document.querySelector(
                '.glide__bullet--active .glide__bullet-inner'
            );
            innerBlue.style.removeProperty('width');
            hCarousel.classList.remove('paused');
        }

        if (hCarousel.classList.contains('halt')) {
            hCarousel.classList.remove('halt');

            const activeBullet = document.querySelector(
                '.glide__bullet--reset'
            );
            activeBullet.classList.add('glide__bullet--active');
            activeBullet.classList.remove('glide__bullet--reset');
        }
        heroCarousel.play();
    });

    /* remove existing progress when using left/right arrows */
    function removeInlineWidth() {
        const inners = document.querySelectorAll('.glide__bullet-inner');
        inners.forEach((inner) => {
            inner.style.removeProperty('width');
        });

        if (!hCarousel.classList.contains('paused')) {
            heroCarousel.pause();
        }
    }

    const carouselArrows = document.querySelectorAll('.glide__arrow');
    carouselArrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
            removeInlineWidth();
            heroCarousel.pause();
            hCarousel.classList.add('halt');
            hCarousel.classList.remove('paused');
            showPauseButton();

            setTimeout(() => {
                const activeBullet = document.querySelector(
                    '.glide__bullet--active'
                );
                activeBullet.classList.add('glide__bullet--reset');
                activeBullet.classList.remove('glide__bullet--active');
            }, 500);
        });
    });

    /* determine which image to use */

    const windowWidth = window.innerWidth;

    const slides = document.querySelectorAll('.js-hero-carousel-slide');

    slides.forEach((slide) => {
        const current = slide;
        const { bigImage } = slide.dataset;
        const { smallImage } = slide.dataset;

        if (windowWidth <= 1024) {
            current.style.backgroundImage = `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)),url(${
                smallImage || bigImage
            })`;
        } else {
            current.style.backgroundImage = `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)),url(${
                bigImage || smallImage
            })`;
        }
    });
}

window.addEventListener('DOMContentLoaded', initiateSlider);
